export function getRemainingTime(startTime: Date, endTime: string) {
  // TODO: extract to aviatakz
  const milliseconds = Date.parse(endTime) - Date.parse(startTime.toString());
  const seconds = Math.floor((milliseconds / 1000) % 60);
  const minutes = Math.floor((milliseconds / 1000 / 60) % 60);
  const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
  const secondsLeft = milliseconds % (1000 * 60 * 60 * 24);
  const hours =
    days === 0
      ? Math.floor(milliseconds / (1000 * 60 * 60))
      : Math.floor(secondsLeft / (1000 * 60 * 60));

  return {
    days,
    hours,
    minutes,
    seconds,
    milliseconds,
  };
}
